export const textForDelivery = {
  dispatchPrice: '100',
  dispatchDays: '1-2',
};

export const theme = 'Sportscraft';